<template>
  <div class="container-fluid mt-3 feedback-page">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6 col-xl-5">
        <div class="p-3 border rounded shadow-sm bg-white mb-3">
          <h5 class="mb-3 font-weight-bold">意见收集</h5>
          <div class="mb-2 text-muted small">我的昵称：{{ currentUserName || '未登录' }}</div>
          <b-form-group label="你的意见" label-for="fb-content" label-class="font-weight-bold">
            <b-form-textarea id="fb-content" v-model="fbContent" rows="4" max-rows="8" placeholder="请输入你的意见或建议..."></b-form-textarea>
          </b-form-group>
          <div class="d-flex align-items-center mb-2">
            <b-form-file v-model="fbFile" accept="image/*" browse-text="选择图片" placeholder="可选，上传图片" @input="onUpload" size="sm"></b-form-file>
          </div>
          <div class="d-flex flex-wrap mb-2" v-if="fbImages.length > 0">
            <div class="position-relative mr-2 mb-2" v-for="(url, idx) in fbImages" :key="idx">
                <img :src="url" alt="预览" class="preview-thumb" @click="openImage(url)" />
                <div class="remove-icon" @click="removeImage(idx)">×</div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
             <b-button variant="primary" size="sm" @click="onSubmit" :disabled="submitting" class="px-4">提交意见</b-button>
          </div>
          <b-alert :show="fbMsg!==''" variant="info" class="mt-2" dismissible @dismissed="fbMsg=''">{{ fbMsg }}</b-alert>
        </div>
        
        <div class="mt-4">
          <h6 class="mb-3 font-weight-bold pl-1 border-left-primary">大家的意见</h6>
          <div v-if="feedbackList.length === 0" class="text-center text-muted py-5">暂无意见，快来抢沙发吧~</div>
          <div v-for="item in feedbackList" :key="item.id" class="mb-3 p-3 border rounded bg-white shadow-sm feedback-item">
            <div class="mb-2 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                    <div class="avatar-circle mr-2">{{ item.username ? item.username.substring(0,1).toUpperCase() : 'U' }}</div>
                    <div>
                        <div class="font-weight-bold text-dark" style="font-size: 0.9rem;">{{ item.username }}</div>
                        <div class="text-muted" style="font-size: 0.75rem;">{{ item.created_time }}</div>
                    </div>
                </div>
                <div class="d-flex align-items-center">
                    <b-button v-if="currentUserId===item.user_id" variant="link" size="sm" class="p-0 mr-3 text-secondary" @click="deleteFeedback(item)"><img :src="deleteIcon" alt="delete" class="thumb-icon" /></b-button>
                    <div class="d-flex align-items-center cursor-pointer" @click="toggleFeedbackLike(item)">
                        <span class="mr-1" :class="{'text-danger': item.liked_by_me, 'text-secondary': !item.liked_by_me}">
                             <i class="iconfont" :class="item.liked_by_me ? 'icon-good-fill' : 'icon-good'">👍</i>
                        </span>
                        <small :class="{'text-danger': item.liked_by_me, 'text-muted': !item.liked_by_me}">{{ item.likes || 0 }}</small>
                    </div>
                </div>
            </div>
            <div class="mb-2 text-break" style="font-size: 0.95rem; line-height: 1.5;">{{ item.content }}</div>
            <div class="d-flex flex-wrap mb-2" v-if="item.images && item.images.length">
              <img v-for="(url, idx) in item.images" :key="idx" :src="fullUrl(url)" alt="图片" class="list-thumb" @click="openImage(fullUrl(url))" />
            </div>
            
            <div class="bg-light p-2 rounded mt-2" v-if="item.comments && item.comments.length > 0">
              <div v-for="c in item.comments" :key="c.id" class="mb-1 d-flex align-items-start comment-item">
                <span class="font-weight-bold mr-1" style="font-size: 0.85rem; color: #333;">{{ c.username }}：</span>
                <span class="flex-grow-1 text-break" style="font-size: 0.85rem; color: #555;">{{ c.content }}</span>
                <div class="d-flex align-items-center ml-2 flex-shrink-0">
                     <small class="text-muted mr-2" style="font-size: 0.7rem;">{{ c.created_time ? c.created_time.substring(5, 16) : '' }}</small>
                     <span class="cursor-pointer mr-2" @click="toggleLike(c)" :class="{'text-danger': c.liked_by_me, 'text-secondary': !c.liked_by_me}">
                        <small>👍 {{ c.likes || 0 }}</small>
                     </span>
                     <b-button v-if="currentUserId===c.user_id" variant="link" size="sm" class="p-0 text-secondary" @click="deleteComment(c)">×</b-button>
                </div>
              </div>
            </div>
            
            <div class="d-flex align-items-center mt-2 pt-2 border-top">
                <b-form-input v-model="commentInputs[item.id]" size="sm" placeholder="写下你的评论..." class="mr-2 rounded-pill bg-light border-0"></b-form-input>
                <b-button variant="link" size="sm" class="text-primary font-weight-bold text-nowrap" @click="submitComment(item.id)" :disabled="!commentInputs[item.id]">发送</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="imageViewer" title="图片预览" hide-footer centered size="xl" body-class="p-0">
      <div class="text-center bg-dark">
        <img :src="imageViewerSrc" alt="图片预览" class="image-large" />
      </div>
    </b-modal>
  </div>
 </template>

 <script>
 import { request_zzquant } from "network/request.js"
 export default {
  data(){
    return { fbContent:'', fbFile:null, fbImages:[], fbMsg:'', submitting:false, feedbackList:[], commentInputs:{}, currentUserId:null, currentUserName:null, deleteIcon: require('assets/img/delete.png'), imageViewerSrc:'' }
  },
  mounted(){ this.loadUser(); this.loadList() },
  methods:{
    onUpload(){
       if(!this.fbFile){ return }
       const form = new FormData()
       form.append('file', this.fbFile)
       request_zzquant({ url: '/feedback/upload', method: 'POST', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
         .then(res => { const url = res.data && res.data.data ? res.data.data.url : null; if(url){ const full = 'https://api.zizizaizai.com' + url; this.fbImages.push(full); this.fbFile=null; } })
         .catch(() => { this.fbMsg = '图片上传失败，请重试'; this.fbFile=null; })
    },
    openImage(url){ this.imageViewerSrc = url; try{ this.$refs.imageViewer.show() }catch(e){ void 0 } },
    removeImage(idx){
       this.fbImages.splice(idx, 1);
    },
    loadUser(){
      request_zzquant({ url:'/user/info', method:'GET' }).then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; this.currentUserId=d.id||null; this.currentUserName=d.username||null; this.applyLikeMarks() }).catch(()=>{ this.currentUserId=null; this.currentUserName=null; })
    },
     onSubmit(){
       if(!this.fbContent || this.fbContent.trim()===''){ this.fbMsg='请输入意见内容'; return }
       this.submitting=true
       request_zzquant({ url:'/feedback/submit', method:'POST', data:{ content:this.fbContent.trim(), images:this.fbImages } })
         .then(() => { this.fbMsg='提交成功，感谢你的建议！'; this.fbContent=''; this.fbImages=[]; this.submitting=false; this.loadList(); })
         .catch(() => { this.fbMsg='提交失败，请登录后重试'; this.submitting=false; })
     },
    loadList(){
      request_zzquant({ url:'/feedback/list', method:'GET' })
        .then(res => { const data = res.data && res.data.data ? res.data.data : []; this.feedbackList = Array.isArray(data) ? data : []; this.normalizeLikes(); this.applyLikeMarks() })
        .catch(() => {})
    },
    normalizeLikes(){
      const list = Array.isArray(this.feedbackList) ? this.feedbackList : [];
      for(const item of list){ item.liked_by_me = typeof item.liked_by_me==='boolean' ? item.liked_by_me : !!(item.liked || item.my_liked || item.liked_me || item.like_by_me); const cs = Array.isArray(item.comments) ? item.comments : []; for(const c of cs){ c.liked_by_me = typeof c.liked_by_me==='boolean' ? c.liked_by_me : !!(c.liked || c.my_liked || c.liked_me || c.like_by_me) } }
    },
    applyLikeMarks(){
      const uid = this.currentUserId || 0; if(!uid) return;
      const list = Array.isArray(this.feedbackList) ? this.feedbackList : [];
      const itemLiked = this._getLikedSet('fb_item');
      const cLiked = this._getLikedSet('fb_comment');
      for(const item of list){
        if(Array.isArray(item.liked_user_ids)){ item.liked_by_me = item.liked_by_me || item.liked_user_ids.includes(uid) }
        if(itemLiked.has(item.id)) item.liked_by_me = true;
        const cs = Array.isArray(item.comments) ? item.comments : [];
        for(const c of cs){ if(Array.isArray(c.liked_user_ids)){ c.liked_by_me = c.liked_by_me || c.liked_user_ids.includes(uid) } if(cLiked.has(c.id)) c.liked_by_me = true; }
      }
    },
    _getLikedSet(type){
      const uid = this.currentUserId || 0; const key = `zzq_${type}_liked_${uid}`;
      try{ const raw = localStorage.getItem(key) || '[]'; const arr = JSON.parse(raw); if(Array.isArray(arr)) return new Set(arr); }catch(e){ return new Set() }
      return new Set();
    },
    _saveLikedSet(type, set){
      const uid = this.currentUserId || 0; const key = `zzq_${type}_liked_${uid}`; try{ localStorage.setItem(key, JSON.stringify(Array.from(set))) }catch(e){ void 0 }
    },
     submitComment(fid){
       const text = (this.commentInputs[fid] || '').trim(); if(!text){ return }
       request_zzquant({ url:'/feedback/comment', method:'POST', data:{ feedback_id: fid, content: text } })
         .then(() => { this.commentInputs[fid]=''; this.loadList(); })
         .catch(() => {})
     },
     deleteFeedback(item){
       request_zzquant({ url:'/feedback/delete', method:'POST', data:{ feedback_id: item.id } })
         .then(()=>{ this.loadList() })
         .catch(()=>{})
     },
    toggleFeedbackLike(item){
      request_zzquant({ url:'/feedback/like', method:'POST', data:{ feedback_id: item.id } })
        .then(res=>{ const d=res.data&&res.data.data?res.data.data:{}; item.likes=d.likes; item.liked_by_me=d.liked; const set = this._getLikedSet('fb_item'); if(d.liked){ set.add(item.id) } else { set.delete(item.id) } this._saveLikedSet('fb_item', set) })
        .catch(()=>{})
    },
    toggleLike(c){
      request_zzquant({ url:'/feedback/comment/like', method:'POST', data:{ comment_id: c.id } })
        .then(res => { const d=res.data&&res.data.data?res.data.data:{}; c.likes=d.likes; c.liked_by_me=d.liked; const set = this._getLikedSet('fb_comment'); if(d.liked){ set.add(c.id) } else { set.delete(c.id) } this._saveLikedSet('fb_comment', set) })
        .catch(() => {})
    },
     deleteComment(c){
       request_zzquant({ url:'/feedback/comment/delete', method:'POST', data:{ comment_id: c.id } })
         .then(()=>{ this.loadList() })
         .catch(()=>{})
     },
    fullUrl(url){ if(!url){ return '' } if(url.startsWith('http')) return url; return 'https://api.zizizaizai.com' + url }
    }
  }
</script>

<style>
.thumb-icon{ width:16px; height:16px; vertical-align:middle; }
.list-thumb{ width:80px; height:80px; object-fit:cover; margin-right:6px; margin-bottom:6px; border:1px solid #eee; border-radius:4px; cursor:pointer; transition: transform 0.2s; }
.list-thumb:hover { transform: scale(1.05); }
.preview-thumb{ width:80px; height:80px; object-fit:cover; border:1px solid #ddd; border-radius:4px; cursor:pointer; }
.remove-icon { position: absolute; top: -8px; right: -8px; width: 20px; height: 20px; background: rgba(0,0,0,0.6); color: #fff; border-radius: 50%; text-align: center; line-height: 18px; font-size: 14px; cursor: pointer; z-index: 10; }
.image-large{ max-width:100%; max-height:85vh; object-fit:contain; }
.avatar-circle { width: 40px; height: 40px; border-radius: 50%; background-color: #007bff; color: white; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 1.2rem; }
.border-left-primary { border-left: 4px solid #007bff; }
.cursor-pointer { cursor: pointer; }
.feedback-page { padding-bottom: 20px; }
@media (max-width: 576px) {
  .feedback-page { padding-bottom: 80px; }
}
.comment-item:last-child { margin-bottom: 0 !important; }
</style>
